export const selectParticipants = (state) => [state.participants, state.setParticipants]
